const SET_SELECTED_BRANCH = 'SET_SELECTED_BRANCH';
const SET_SELECTED_REQUISITION_TYPE = "SET_SELECTED_REQUISITION_TYPE";
const SET_IREQUEST = "SET_IREQUEST";
const SET_IMANAGEMENT_VEHICLE = "SET_IMANAGEMENT_VEHICLE"
const SET_INON_STANDARD_EQUIPMENT = "SET_INON_STANDARD_EQUIPMENT"
const SET_IPRODUCTION_VEHICLE = "SET_IPRODUCTION_VEHICLE";
const SET_IREASON = "SET_IREASON";

const SET_CART_IREQUEST = "SET_CART_IREQUEST";
const SET_CART_IPRODUCTION_VEHICLE = "SET_CART_IPRODUCTION_VEHICLE";
const SET_CART_INON_STANDARD_EQUIPMENT = "SET_CART_INON_STANDARD_EQUIPMENT";
const SET_CART_IMANAGEMENT_VEHICLE = "SET_CART_IMANAGEMENT_VEHICLE"
const SET_CART_IREASON = "SET_CART_IREASON";

const SET_SHOW_ITEM_DETAILS = "SET_SHOW_ITEM_DETAILS"
const SET_IS_ADD_TO_CART_CLICK = "SET_IS_ADD_TO_CART_CLICK"
const SET_IS_REASON_CHANGE = "SET_IS_REASON_CHANGE"

// Order Create 
const SET_IORDER_REQUEST = "SET_IORDER_REQUEST"
const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST"
const SET_IS_SUBMIT_CLICK = "SET_IS_SUBMIT_CLICK"
const SET_IS_SAVE_CLICK = "SET_IS_SAVE_CLICK"
const SET_ORDER_LEADR_NUMBER = "SET_ORDER_LEADR_NUMBER"
const SET_IS_ORDER_CREATION_SUCCESS = "SET_IS_ORDER_CREATION_SUCCESS"

// EDIT Order
const SET_ORDER_ID = "SET_ORDER_ID"
const SET_IS_EDIT_ORDER = "SET_IS_EDIT_ORDER"

 //Managed Equipment 
 const SET_MANAGED_EQUIPMENT_VALUES = 'SET_MANAGED_EQUIPMENT_VALUES'
 const SET_IMANAGED_EQUIPMENT = 'SET_IMANAGED_EQUIPMENT'
 const SET_CART_IMANAGED_EQUIPMENT = 'SET_CART_IMANAGED_EQUIPMENT'
 const SET_SELECTED_EQUIPMENT_TYPE = 'SET_SELECTED_EQUIPMENT_TYPE'
 const SET_SELECTED_CATALOG_ITEM = 'SET_SELECTED_CATALOG_ITEM'
 const SET_IS_CATALOG_ITEM_EXIST = 'SET_IS_CATALOG_ITEM_EXIST'

 const SET_IS_CHANGES_OCCURED = 'SET_IS_CHANGES_OCCURED'

 const SET_ISMAND_FLAG = 'SET_ISMAND_FLAG'
 const SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED = 'SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED'
 const SET_ORDER_EDIT_NAVIGATION_CHANGE='SET_ORDER_EDIT_NAVIGATION_CHANGE'
 const SET_IS_ADD_ASSET_CLICK='SET_IS_ADD_ASSET_CLICK'
 const SET_IS_ADD_ITEM_CLICK='SET_IS_ADD_ITEM_CLICK'



 //Edit request types
 const SET_EDIT_REQUEST_DETAILS = 'SET_REQUEST_DETAILS'
 const SET_IS_EDIT_REQUEST_CLICK = 'SET_IS_EDIT_REQUEST_CLICK'
 const SET_IS_ADD_REQUISITION_TYPE_CLICK = 'SET_IS_ADD_REQUISITION_TYPE_CLICK'
 const SET_IS_UPDATE_SUCCESS_ALERT = 'SET_IS_UPDATE_SUCCESS_ALERT'

const SET_IS_APPROVAL_OVERRIDE_FLAG = "SET_IS_APPROVAL_OVERRIDE_FLAG"

const SET_IS_DEALER_SAMEFORALL_FLAG = "SET_IS_DEALER_SAMEFORALL_FLAG"

export {
    // SET_REQUEST,
    // SET_SELECTED_SUBTYPE_ID,
    SET_SELECTED_BRANCH,
    SET_SELECTED_REQUISITION_TYPE,
    SET_IREQUEST,
    SET_IMANAGEMENT_VEHICLE,
    SET_INON_STANDARD_EQUIPMENT,
    SET_IPRODUCTION_VEHICLE,
    SET_IREASON,
    SET_CART_IREQUEST,
    SET_CART_IPRODUCTION_VEHICLE,
    SET_CART_INON_STANDARD_EQUIPMENT,
    SET_CART_IMANAGEMENT_VEHICLE,
    SET_CART_IREASON,
    SET_SHOW_ITEM_DETAILS,
    SET_IS_ADD_TO_CART_CLICK,
    SET_IS_REASON_CHANGE,
    SET_IORDER_REQUEST,
    CREATE_ORDER_REQUEST,
    SET_IS_SUBMIT_CLICK,
    SET_IS_SAVE_CLICK,
    SET_ORDER_LEADR_NUMBER,
    SET_IS_ORDER_CREATION_SUCCESS,
    SET_ORDER_ID,
    SET_IS_EDIT_ORDER,
    SET_MANAGED_EQUIPMENT_VALUES,
    SET_CART_IMANAGED_EQUIPMENT,
    SET_IMANAGED_EQUIPMENT,
    SET_SELECTED_EQUIPMENT_TYPE,
    SET_SELECTED_CATALOG_ITEM,
    SET_IS_CATALOG_ITEM_EXIST,
    SET_IS_CHANGES_OCCURED,
    SET_ISMAND_FLAG,
    SET_PRODUCTION_VEHICLE_DANGEROUSLY_SET_EXPANDED,
    SET_ORDER_EDIT_NAVIGATION_CHANGE,
    SET_IS_ADD_ASSET_CLICK,
    SET_IS_ADD_ITEM_CLICK,
    SET_EDIT_REQUEST_DETAILS,
    SET_IS_EDIT_REQUEST_CLICK,
    SET_IS_ADD_REQUISITION_TYPE_CLICK,
    SET_IS_UPDATE_SUCCESS_ALERT,
    SET_IS_APPROVAL_OVERRIDE_FLAG,
    SET_IS_DEALER_SAMEFORALL_FLAG
};
